import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons"
import { AppContext } from "../shared/context/AppContext"

// Import CSS
import "./Footer.css"

const SOCIALS = [
  {
    name: "Facebook",
    icon: faFacebook,
    href: "https://www.facebook.com/escapemysteryNL",
  },
  {
    name: "Instagram",
    icon: faInstagram,
    href: "https://www.instagram.com/escapemysterynl/",
  },
  {
    name: "LinkedIn",
    icon: faLinkedin,
    href: "https://www.linkedin.com/company/escape-mystery",
  },
]

function Footer() {
  const { language } = useContext(AppContext)
  const nl = language === "NL"
  // Everything @escapemystery.nl reaches us, so each language gets its own word
  const businessEmail = nl ? "zakelijk@escapemystery.nl" : "business@escapemystery.nl"

  return (
    <footer className="Footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <p className="footer-name">Escape Mystery</p>
          <p>
            {nl
              ? "Online escape rooms in echte 360° omgevingen. Speel thuis, met vrienden, familie of collega's."
              : "Online escape rooms in real 360° locations. Play from home, with friends, family or colleagues."}
          </p>
          <ul className="footer-socials">
            {SOCIALS.map((social) => (
              <li key={social.name}>
                <a
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.name}
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <nav className="footer-column" aria-label="Website">
          <p className="footer-column-title">
            {nl ? "Op deze website" : "This website"}
          </p>
          <ul>
            <li>
              <Link to="/escaperooms">
                {nl ? "Alle escape rooms" : "All escape rooms"}
              </Link>
            </li>
            <li>
              <Link to="/custom_escape_room">
                {nl ? "Escape room op maat" : "Custom escape room"}
              </Link>
            </li>
            <li>
              <Link to="/faq">
                {nl ? "Veelgestelde vragen" : "Frequently asked questions"}
              </Link>
            </li>
          </ul>
        </nav>

        <div className="footer-column">
          <p className="footer-column-title">Contact</p>
          <ul>
            <li>
              <span className="footer-label">
                {nl ? "Algemeen" : "General"}
              </span>
              <a href="mailto:info@escapemystery.nl">info@escapemystery.nl</a>
            </li>
            <li>
              <span className="footer-label">
                {nl ? "Zakelijk" : "Business"}
              </span>
              <a href={`mailto:${businessEmail}`}>{businessEmail}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Escape Mystery</p>
        <ul>
          <li>
            <Link to="/voorwaarden">
              {nl ? "Algemene voorwaarden" : "Terms and conditions"}
            </Link>
          </li>
          <li>
            <Link to="/privacy">
              {nl ? "Privacyverklaring" : "Privacy statement"}
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
